// extracted by mini-css-extract-plugin
module.exports = {"homeImgBackground":"home_homeImgBackground__2Ch4l","hero":"home_hero__3WBfA","cardCategory":"home_cardCategory__15YXd","linkDecoration":"home_linkDecoration__1-X5l"};